/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component, Optional } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { NavigationEnd, Router } from '@angular/router';
import { AppRouter } from '@gh/common-shared';
import { KeycloakService } from '@gh/core-auth-keycloak';
import { TranslationService } from '@gh/core-mls';
import { DialogService } from '@gh/core-ui';
import { getUrlSegment, openInThisWindow, replaceUrlSegment } from '@gh/core-util';
import { filter$ } from '@gh/rx/operators';
import { SupplierUserContext } from '@gh/supplier-shared';
import { supplierOfficeInfoDialogRoute } from '../supplier-office-info-dialog/supplier-office-info-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/flex-layout";
import * as i2 from "@gh/supplier-shared";
import * as i3 from "@gh/core-ui";
import * as i4 from "@gh/common-shared";
import * as i5 from "@angular/router";
import * as i6 from "@gh/core-mls";
import * as i7 from "@gh/core-auth-keycloak";
import * as i8 from "@angular/common";
import * as i9 from "../../../common-external-shared/components/ext-root-layout/ext-root-layout.component";
import * as i10 from "../../../common-external-shared/components/ext-navigation/ext-navigation.component";
import * as i11 from "../../../common-external-shared/components/ext-navigation/ext-navigation-item.component";
import * as i12 from "@angular/material/slide-toggle";
import * as i13 from "@angular/flex-layout/flex";
import * as i14 from "@angular/flex-layout/extended";
import * as i15 from "../../../common-external-shared/infinite-scroll/ext-infinite-scroll-viewport.directive";
import * as i16 from "@angular/material/button";
import * as i17 from "@angular/material/tooltip";
import * as i18 from "@angular/material/icon";
import * as i19 from "@angular/material/form-field";
import * as i20 from "@angular/material/select";
import * as i21 from "@angular/material/core";
import * as i22 from "../../../common-shared/routing/app-router-outlet.directive";
import * as i23 from "../../../common-external-shared/components/ext-preloader/ext-preloader.component";
import * as i24 from "../../../common-external-shared/components/ext-no-data/ext-no-data.component";
import * as i25 from "../../../core-mls/translation/translate.pipe";
function SupplierAppComponent_gh_ext_root_layout_0_a_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("href", "tel:", ctx_r1.currentSelectedOffice.phone, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(1, 2, "lbl_office_phone"));
} }
function SupplierAppComponent_gh_ext_root_layout_0_div_25_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function SupplierAppComponent_gh_ext_root_layout_0_div_25_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); var ctx_r9 = i0.ɵɵnextContext(3); return ctx_r9.onOpenOfficeInfo(); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(1, 1, "lbl_office_info"));
} }
function SupplierAppComponent_gh_ext_root_layout_0_div_25_mat_option_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", ctx_r7.allOffices);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "lbl_all"));
} }
function SupplierAppComponent_gh_ext_root_layout_0_div_25_mat_option_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var office_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(office_r11.name);
} }
function SupplierAppComponent_gh_ext_root_layout_0_div_25_mat_option_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_no_active_offices"));
} }
function SupplierAppComponent_gh_ext_root_layout_0_div_25_mat_option_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtemplate(1, SupplierAppComponent_gh_ext_root_layout_0_div_25_mat_option_7_ng_container_1_Template, 2, 1, "ng-container", 0);
    i0.ɵɵtemplate(2, SupplierAppComponent_gh_ext_root_layout_0_div_25_mat_option_7_ng_container_2_Template, 3, 3, "ng-container", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var office_r11 = ctx.$implicit;
    var ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", office_r11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.hasOffices);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.hasOffices);
} }
function SupplierAppComponent_gh_ext_root_layout_0_div_25_Template(rf, ctx) { if (rf & 1) {
    var _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, SupplierAppComponent_gh_ext_root_layout_0_div_25_button_1_Template, 3, 3, "button", 22);
    i0.ɵɵelementStart(2, "div", 23);
    i0.ɵɵelementStart(3, "mat-form-field", 24);
    i0.ɵɵelementStart(4, "mat-select", 25);
    i0.ɵɵlistener("selectionChange", function SupplierAppComponent_gh_ext_root_layout_0_div_25_Template_mat_select_selectionChange_4_listener($event) { i0.ɵɵrestoreView(_r16); var ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.onCurrentOfficeChange($event.value); });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtemplate(6, SupplierAppComponent_gh_ext_root_layout_0_div_25_mat_option_6_Template, 3, 4, "mat-option", 26);
    i0.ɵɵtemplate(7, SupplierAppComponent_gh_ext_root_layout_0_div_25_mat_option_7_Template, 3, 3, "mat-option", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.currentSelectedOffice && ctx_r2.currentSelectedOffice.id);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(5, 5, "lbl_office"));
    i0.ɵɵproperty("value", ctx_r2.currentSelectedOffice);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isAllOfficesOptionVisible);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.offices);
} }
function SupplierAppComponent_gh_ext_root_layout_0_div_26_a_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 37);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵelement(2, "mat-icon", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 39);
    i0.ɵɵelementStart(4, "div", 34);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 40);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate1("href", "tel:", ctx_r17.currentSelectedOffice.phone, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 3, "lbl_office_phone"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r17.currentSelectedOffice.phone);
} }
function SupplierAppComponent_gh_ext_root_layout_0_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵelementStart(2, "div", 32);
    i0.ɵɵelement(3, "mat-icon", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 32);
    i0.ɵɵelementStart(5, "div", 34);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 35);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, SupplierAppComponent_gh_ext_root_layout_0_div_26_a_10_Template, 9, 5, "a", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 3, "lbl_office_address"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.currentSelectedOffice.description);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.currentSelectedOffice.phone);
} }
function SupplierAppComponent_gh_ext_root_layout_0_ng_container_29_gh_ext_preloader_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "gh-ext-preloader", 43);
} if (rf & 2) {
    i0.ɵɵproperty("size", 120)("loading", true);
} }
function SupplierAppComponent_gh_ext_root_layout_0_ng_container_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "router-outlet", null, 41);
    i0.ɵɵtemplate(3, SupplierAppComponent_gh_ext_root_layout_0_ng_container_29_gh_ext_preloader_3_Template, 1, 2, "gh-ext-preloader", 42);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var _r18 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !_r18.isActivated);
} }
function SupplierAppComponent_gh_ext_root_layout_0_gh_ext_no_data_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "gh-ext-no-data", 44);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
} if (rf & 2) {
    i0.ɵɵpropertyInterpolate("initial", i0.ɵɵpipeBind1(1, 3, "lbl_no"));
    i0.ɵɵpropertyInterpolate("dataName", i0.ɵɵpipeBind1(2, 5, "lbl_data"));
    i0.ɵɵpropertyInterpolate("message", i0.ɵɵpipeBind1(3, 7, "lbl_no_data_sorry"));
} }
var _c0 = function (a1) { return ["/offices", a1, "purchase-orders"]; };
var _c1 = function (a1) { return ["/offices", a1, "invoices"]; };
var _c2 = function (a1) { return ["/offices", a1, "shared-docs"]; };
var _c3 = function (a1) { return ["/offices", a1, "calendar"]; };
function SupplierAppComponent_gh_ext_root_layout_0_Template(rf, ctx) { if (rf & 1) {
    var _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "gh-ext-root-layout");
    i0.ɵɵelementStart(1, "gh-ext-navigation", 1);
    i0.ɵɵelement(2, "gh-ext-navigation-item", 2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "gh-ext-navigation-item", 2);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "gh-ext-navigation-item", 2);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelement(8, "gh-ext-navigation-item", 2);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementStart(10, "gh-ext-navigation-item", 3);
    i0.ɵɵelementStart(11, "mat-slide-toggle", 4);
    i0.ɵɵlistener("change", function SupplierAppComponent_gh_ext_root_layout_0_Template_mat_slide_toggle_change_11_listener($event) { i0.ɵɵrestoreView(_r21); var ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.onReceiveEmailsChange($event.checked); });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "gh-ext-navigation-item", 5);
    i0.ɵɵlistener("click", function SupplierAppComponent_gh_ext_root_layout_0_Template_gh_ext_navigation_item_click_14_listener() { i0.ɵɵrestoreView(_r21); var ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.onChangePassword(); });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "gh-ext-navigation-item", 6);
    i0.ɵɵlistener("click", function SupplierAppComponent_gh_ext_root_layout_0_Template_gh_ext_navigation_item_click_16_listener() { i0.ɵɵrestoreView(_r21); var ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.onLogout(); });
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(18, 7);
    i0.ɵɵtemplate(19, SupplierAppComponent_gh_ext_root_layout_0_a_19_Template, 3, 4, "a", 8);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(20, "div", 9);
    i0.ɵɵelementStart(21, "div", 10);
    i0.ɵɵelementStart(22, "div", 11);
    i0.ɵɵelementStart(23, "div", 12);
    i0.ɵɵelement(24, "img", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(25, SupplierAppComponent_gh_ext_root_layout_0_div_25_Template, 8, 7, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, SupplierAppComponent_gh_ext_root_layout_0_div_26_Template, 11, 5, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 16);
    i0.ɵɵelementStart(28, "div", 17);
    i0.ɵɵtemplate(29, SupplierAppComponent_gh_ext_root_layout_0_ng_container_29_Template, 4, 1, "ng-container", 0);
    i0.ɵɵtemplate(30, SupplierAppComponent_gh_ext_root_layout_0_gh_ext_no_data_30_Template, 4, 9, "gh-ext-no-data", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 22, "lbl_purchase_orders"));
    i0.ɵɵproperty("disabled", !ctx_r0.hasOffices)("link", i0.ɵɵpureFunction1(36, _c0, ctx_r0.groupedOfficeId));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(5, 24, "lbl_invoices"));
    i0.ɵɵproperty("disabled", !ctx_r0.hasOffices)("link", i0.ɵɵpureFunction1(38, _c1, ctx_r0.currentOffice.id));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 26, "lbl_shared_documents"));
    i0.ɵɵproperty("disabled", !ctx_r0.hasOffices)("link", i0.ɵɵpureFunction1(40, _c2, ctx_r0.currentOffice.id));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(9, 28, "lbl_calendar"));
    i0.ɵɵproperty("disabled", !ctx_r0.hasOffices)("link", i0.ɵɵpureFunction1(42, _c3, ctx_r0.groupedOfficeId));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", ctx_r0.receiveEmails);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 30, "lbl_receive_emails"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(15, 32, "lbl_change_password"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(17, 34, "lbl_logout"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.currentSelectedOffice && ctx_r0.currentSelectedOffice.phone);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r0.isOfficeSelectorVisible);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.currentSelectedOffice && ctx_r0.currentSelectedOffice.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ghExtInfiniteScrollViewport", ctx_r0.infiniteScrollViewport);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hasOffices);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.hasOffices);
} }
var ALL_OFFICES = {};
var EMPTY_OFFICE = {};
var ROUTE_CALENDAR = 'calendar';
var ROUTE_ORDERS = 'purchase-orders';
var SupplierAppComponent = /** @class */ (function () {
    function SupplierAppComponent(observer, userContext, dialogs, appRouter, router, translations, keycloak) {
        this.observer = observer;
        this.userContext = userContext;
        this.dialogs = dialogs;
        this.appRouter = appRouter;
        this.router = router;
        this.translations = translations;
        this.keycloak = keycloak;
        this.allOffices = ALL_OFFICES;
        this.isCalendarRoute = false;
        this.isOrdersRoute = false;
        this.currentSelectedOffice = EMPTY_OFFICE;
        this.isMediaLtMd = false;
    }
    Object.defineProperty(SupplierAppComponent.prototype, "currentOffice", {
        get: function () {
            return this.userContext.currentOffice || EMPTY_OFFICE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierAppComponent.prototype, "receiveEmails", {
        get: function () {
            return this.userContext.data.receiveEmails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierAppComponent.prototype, "officeId", {
        get: function () {
            return this.userContext.currentOffice.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierAppComponent.prototype, "groupedOfficeId", {
        get: function () {
            if (this.isCalendarRoute || this.isOrdersRoute) {
                return this.currentSelectedOffice === ALL_OFFICES ? 'all' : this.currentSelectedOffice.id;
            }
            else {
                return 'all';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierAppComponent.prototype, "hasSeveralOffices", {
        get: function () {
            return this.userContext.offices.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierAppComponent.prototype, "isAllOfficesOptionVisible", {
        get: function () {
            return this.hasSeveralOffices && (this.isCalendarRoute || this.isOrdersRoute);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierAppComponent.prototype, "isOfficeSelectorVisible", {
        get: function () {
            return !this.isCalendarRoute || (this.isCalendarRoute && this.isMediaLtMd);
        },
        enumerable: true,
        configurable: true
    });
    SupplierAppComponent.prototype.ngOnInit = function () {
        var _this = this;
        // user context may be not initialized in case of error on login
        if (!this.userContext.isInitialized()) {
            return;
        }
        var offices = this.userContext.offices;
        this.offices = offices.length > 0 ? offices : [EMPTY_OFFICE];
        this.hasOffices = offices.length > 0;
        this.mediaSubscription = this.observer.media$
            .subscribe(function () {
            _this.infiniteScrollViewport = _this.observer.isActive('lt-md') ? 'root' : void 0;
            _this.isMediaLtMd = _this.observer.isActive('lt-md');
        });
        this.router.events
            .pipe(filter$(function (event) { return event instanceof NavigationEnd; }))
            .subscribe(function (event) {
            _this.isCalendarRoute = Boolean(event.url.match(ROUTE_CALENDAR));
            _this.isOrdersRoute = Boolean(event.url.match(ROUTE_ORDERS));
            var officeId = getUrlSegment(_this.appRouter.url, 1);
            _this.currentSelectedOffice = officeId === 'all'
                ? ALL_OFFICES
                : (_this.userContext.getOffice(officeId) || EMPTY_OFFICE);
        });
    };
    SupplierAppComponent.prototype.ngOnDestroy = function () {
        if (this.mediaSubscription) {
            this.mediaSubscription.unsubscribe();
        }
    };
    SupplierAppComponent.prototype.onCurrentOfficeChange = function (office) {
        this.appRouter.navigateByUrl(replaceUrlSegment(this.appRouter.url, 1, office === ALL_OFFICES ? 'all' : office.id));
    };
    SupplierAppComponent.prototype.onOpenOfficeInfo = function (office) {
        this.dialogs.openWithInput(supplierOfficeInfoDialogRoute, {
            office: this.currentOffice,
        });
    };
    SupplierAppComponent.prototype.onChangePassword = function () {
        if (this.keycloak) {
            openInThisWindow(this.keycloak.getChangePasswordUrl());
        }
    };
    SupplierAppComponent.prototype.onReceiveEmailsChange = function (receiveEmails) {
        this.userContext.updateReceiveEmails(receiveEmails);
    };
    SupplierAppComponent.prototype.onLogout = function () {
        this.userContext.logout();
    };
    SupplierAppComponent.ɵfac = function SupplierAppComponent_Factory(t) { return new (t || SupplierAppComponent)(i0.ɵɵdirectiveInject(i1.MediaObserver), i0.ɵɵdirectiveInject(i2.SupplierUserContext), i0.ɵɵdirectiveInject(i3.DialogService), i0.ɵɵdirectiveInject(i4.AppRouter), i0.ɵɵdirectiveInject(i5.Router), i0.ɵɵdirectiveInject(i6.TranslationService), i0.ɵɵdirectiveInject(i7.KeycloakService, 8)); };
    SupplierAppComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SupplierAppComponent, selectors: [["gh-supplier-app"]], decls: 1, vars: 1, consts: [[4, "ngIf"], ["ghExtRootLayoutNavigation", ""], ["align", "start", "type", "link", 3, "title", "disabled", "link"], ["align", "end", "type", "option"], [1, "m-menu-toggle", "reverse", 3, "checked", "change"], ["align", "end", "icon", "gh:settings", "type", "button", 3, "title", "click"], ["align", "end", "icon", "gh:exit-to-app", 3, "title", "click"], ["ghExtRootLayoutMobileBar", ""], ["mat-icon-button", "", "color", "accent", 3, "href", "matTooltip", 4, "ngIf"], ["ghExtRootLayoutTopMenu", ""], ["fxLayout", "row"], ["fxFlex", "", "fxLayout", "row", "fxLayoutAlign", "start center"], ["fxHide.lt-md", "", 1, "m-logo"], ["src", "data:image/png;base64,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"], ["fxFlex", "", "fxLayout", "row", "fxLayoutAlign", "start center", "class", "m-target-office", "ngClass.lt-md", "ext-mobile-content ext-focused-bg", 4, "ngIf"], ["fxLayout", "row", 4, "ngIf"], ["fxLayout", "column", "fxFlex", "", "ghExtRootLayoutContent", "", 1, "m-content"], ["fxFlex", "", "fxLayout", "column", 1, "m-outlet", "ext-elevated-panel", 3, "ghExtInfiniteScrollViewport"], [3, "initial", "dataName", "message", 4, "ngIf"], ["mat-icon-button", "", "color", "accent", 3, "href", "matTooltip"], ["svgIcon", "gh:outline-phone-in-talk"], ["fxFlex", "", "fxLayout", "row", "fxLayoutAlign", "start center", "ngClass.lt-md", "ext-mobile-content ext-focused-bg", 1, "m-target-office"], ["type", "button", "mat-icon-button", "", "class", "m-office-info", "color", "primary", "fxHide", "", "fxShow.lt-xl", "", 3, "matTooltip", "click", 4, "ngIf"], ["fxFlex", "", 1, "m-office-selector"], [1, "ext-main-selector"], ["floatLabel", "always", "ghCompareBy", "id", 3, "placeholder", "value", "selectionChange"], [3, "value", 4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf"], ["type", "button", "mat-icon-button", "", "color", "primary", "fxHide", "", "fxShow.lt-xl", "", 1, "m-office-info", 3, "matTooltip", "click"], ["svgIcon", "gh:info-outline", "ngClass.gt-sm", "s30"], [3, "value"], ["fxHide.lt-xl", "", 1, "m-menu-info"], [1, "m-menu-info__column"], ["svgIcon", "gh:home", 1, "ext-primary-color", "s36"], [1, "m-menu-info__title"], [1, "m-menu-info__value", "m-menu-info__value--wrap"], ["fxHide.lt-md", "", "class", "m-menu-info", 3, "href", 4, "ngIf"], ["fxHide.lt-md", "", 1, "m-menu-info", 3, "href"], ["svgIcon", "gh:outline-phone-in-talk", 1, "ext-primary-color", "s36"], ["fxHide.md", "", 1, "m-menu-info__column"], [1, "m-menu-info__value"], ["outlet", "outlet"], [3, "size", "loading", 4, "ngIf"], [3, "size", "loading"], [3, "initial", "dataName", "message"]], template: function SupplierAppComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, SupplierAppComponent_gh_ext_root_layout_0_Template, 31, 44, "gh-ext-root-layout", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.userContext.isInitialized());
        } }, directives: [i8.NgIf, i9.ExtRootLayoutComponent, i10.ExtNavigationComponent, i11.ExtNavigationItemComponent, i12.MatSlideToggle, i13.DefaultLayoutDirective, i13.DefaultFlexDirective, i13.DefaultLayoutAlignDirective, i14.DefaultShowHideDirective, i15.ExtInfiniteScrollViewportDirective, i16.MatAnchor, i17.MatTooltip, i18.MatIcon, i14.DefaultClassDirective, i19.MatFormField, i20.MatSelect, i8.NgForOf, i16.MatButton, i21.MatOption, i5.RouterOutlet, i22.AppRouterOutletDirective, i23.ExtPreloaderComponent, i24.ExtNoDataComponent], pipes: [i25.TranslatePipe], styles: ["[_nghost-%COMP%] {\n  display: block;\n  height: 100vh; }\n\n.m-content[_ngcontent-%COMP%] {\n  max-width: 100%; }\n\n.m-outlet[_ngcontent-%COMP%] {\n  position: relative; }\n  .m-outlet[_ngcontent-%COMP%]   router-outlet[_ngcontent-%COMP%]    +   * {\n    display: flex;\n    flex-direction: column;\n    min-height: 100%; }\n\n@media (min-width: 960px) and (max-width: 1279px) {\n  .m-logo[_ngcontent-%COMP%] {\n    padding: 30px 50px 20px; } }\n\n@media (min-width: 1280px) {\n  .m-logo[_ngcontent-%COMP%] {\n    padding: 50px 50px 40px; } }\n\n@media (max-width: 959px) {\n  .m-target-office[_ngcontent-%COMP%] {\n    padding-top: 9px;\n    padding-bottom: 9px; }\n  .m-office-info[_ngcontent-%COMP%] {\n    margin-right: 20px; } }\n\n@media (min-width: 960px) {\n  .m-office-info[_ngcontent-%COMP%] {\n    margin-right: 10px; }\n  .m-office-selector[_ngcontent-%COMP%] {\n    max-width: 400px; }\n  .m-menu-info[_ngcontent-%COMP%] {\n    display: flex;\n    flex-direction: row;\n    max-width: 600px;\n    padding: 24px 30px 25px;\n    text-decoration: none;\n    color: black; }\n    .m-menu-info[_ngcontent-%COMP%]:before {\n      content: ' ';\n      border-left: 1px solid rgba(0, 0, 0, 0.12); }\n    .m-menu-info[_ngcontent-%COMP%]   .m-menu-info__column[_ngcontent-%COMP%] {\n      display: flex;\n      flex-direction: column;\n      justify-content: center; }\n      .m-menu-info[_ngcontent-%COMP%]   .m-menu-info__column[_ngcontent-%COMP%]:first-child   .mat-icon[_ngcontent-%COMP%] {\n        margin-left: 25px; }\n    .m-menu-info[_ngcontent-%COMP%]   .m-menu-info__column[_ngcontent-%COMP%]    + .m-menu-info__column[_ngcontent-%COMP%] {\n      margin-left: 15px; }\n    .m-menu-info[_ngcontent-%COMP%]   .m-menu-info__title[_ngcontent-%COMP%] {\n      color: rgba(112, 112, 112, 0.87);\n      font-weight: bold; }\n    .m-menu-info[_ngcontent-%COMP%]   .m-menu-info__value[_ngcontent-%COMP%] {\n      font-size: 24px;\n      white-space: nowrap; }\n    .m-menu-info[_ngcontent-%COMP%]   .m-menu-info__value--wrap[_ngcontent-%COMP%] {\n      white-space: normal; }\n  .m-outlet[_ngcontent-%COMP%] {\n    overflow: auto; } }\n\n@media (max-width: 1279px) {\n  .m-office-selector[_ngcontent-%COMP%]     .mat-form-field-label-wrapper {\n    display: none; } }\n\n.m-menu-toggle[_ngcontent-%COMP%]     .mat-slide-toggle-content {\n  color: white;\n  font-size: 80%;\n  font-weight: 700; }"] });
    return SupplierAppComponent;
}());
export { SupplierAppComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierAppComponent, [{
        type: Component,
        args: [{
                selector: 'gh-supplier-app',
                styleUrls: ['supplier-app.component.scss'],
                templateUrl: 'supplier-app.component.html',
            }]
    }], function () { return [{ type: i1.MediaObserver }, { type: i2.SupplierUserContext }, { type: i3.DialogService }, { type: i4.AppRouter }, { type: i5.Router }, { type: i6.TranslationService }, { type: i7.KeycloakService, decorators: [{
                type: Optional
            }] }]; }, null); })();
